module.exports = __webpack_public_path__ + "img/徳光優斗.63c90d44.jpg";